import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try {
            const raw = localStorage.getItem("estate_user");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("estate_token");
        if (!token) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((res) => {
                setUser(res.data);
                localStorage.setItem("estate_user", JSON.stringify(res.data));
            })
            .catch(() => {
                localStorage.removeItem("estate_token");
                localStorage.removeItem("estate_user");
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const res = await api.post("/auth/login", { email, password });
        localStorage.setItem("estate_token", res.data.token);
        localStorage.setItem("estate_user", JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data.user;
    };

    const register = async (payload) => {
        const res = await api.post("/auth/register", payload);
        localStorage.setItem("estate_token", res.data.token);
        localStorage.setItem("estate_user", JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data.user;
    };

    // Phase 2.5: self-serve signup creates a personal workspace (free) rather than
    // requiring an invitation. Same token/localStorage contract as register/login.
    const signup = async (payload) => {
        const res = await api.post("/onboarding/signup", payload);
        localStorage.setItem("estate_token", res.data.token);
        localStorage.setItem("estate_user", JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data.user;
    };

    const joinWithCode = async (payload) => {
        const res = await api.post("/onboarding/join", payload);
        localStorage.setItem("estate_token", res.data.token);
        localStorage.setItem("estate_user", JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data.user;
    };

    const logout = () => {
        localStorage.removeItem("estate_token");
        localStorage.removeItem("estate_user");
        setUser(null);
        window.location.href = "/login";
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, signup, joinWithCode, logout, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
